import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { gaPageView } from './ga4';

export default function RouteChangeTracker() {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname + location.search;
        gaPageView(path);
    }, [location.pathname, location.search]);

    return null; // NO renderiza nada en pantalla
}